module.exports = __webpack_public_path__ + "imgs/twitter-color.24ce5d863fb5f99dd8cec4a38983538b.svg";